export var KEY_COMPONENT_NAME = 'avue-echart-';